module.exports = __webpack_public_path__ + "static/campaigns-8990fc1aa935677b4d4beb71672dd18d.png";